export interface Movie {
  id: string;
  title: string;
  engTitle: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  description: string;
  longDescription: string;
  director: string;
  cast: string[];
  region: string;
  episodeCount: number;
  episodeUpdated: number;
  status: string;
  image: string;
  bannerImage: string;
  tags: string[];
  updateDate: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-movie-line', count: 128 },
  { name: '古装剧', slug: 'costume', icon: 'ri-ancient-gate-line', count: 32 },
  { name: '都市剧', slug: 'urban', icon: 'ri-building-line', count: 28 },
  { name: '悬疑剧', slug: 'suspense', icon: 'ri-search-eye-line', count: 18 },
  { name: '爱情剧', slug: 'romance', icon: 'ri-heart-line', count: 22 },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-happy-line', count: 15 },
  { name: '科幻剧', slug: 'scifi', icon: 'ri-rocket-line', count: 8 },
  { name: '谍战剧', slug: 'spy', icon: 'ri-shield-flash-line', count: 12 },
  { name: '武侠剧', slug: 'martial', icon: 'ri-sword-line', count: 10 },
  { name: '历史剧', slug: 'history', icon: 'ri-history-line', count: 14 },
];

export const movies: Movie[] = [
  {
    id: 'longing-2025',
    title: '长相思',
    engTitle: 'Lost You Forever',
    year: 2025,
    category: '古装剧',
    categorySlug: 'costume',
    rating: 9.2,
    description: '上古时期，人神妖混居。流落大荒的高辛王姬玖瑶历经百年颠沛之苦，化名玟小六在清水镇落脚，与青丘公子涂山璟、九头妖相柳等人展开一段段刻骨铭心的故事。',
    longDescription: '上古时期，人神妖混居于大荒。流落大荒的高辛王姬玖瑶（小夭）历经百年颠沛之苦，不但失去了身份，也失去了容貌，在清水镇落脚，成为了"无处可去、无人可依、无力自保"的玟小六。她悬壶济世，恣意不羁。与表哥轩辕王子玱玹、青丘公子涂山璟、神农义军将领相柳之间，展开了一段段纠葛缠绵、刻骨铭心的情感故事。剧中展现了奇幻瑰丽的上古世界，细腻刻画了人物间复杂的情感纠葛与成长蜕变。',
    director: '秦榛',
    cast: ['杨紫', '张晚意', '邓为', '檀健次', '王弘毅'],
    region: '中国大陆',
    episodeCount: 40,
    episodeUpdated: 40,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20TV%20series%20poster%20with%20elegant%20female%20lead%20in%20flowing%20traditional%20hanfu%20costume%2C%20ethereal%20mythological%20atmosphere%20with%20soft%20golden%20light%2C%20dreamy%20peach%20blossom%20forest%20background%2C%20cinematic%20poster%20style%20with%20Chinese%20calligraphy%20title%2C%20warm%20amber%20and%20rose%20tones&width=600&height=840&seq=movie-longing-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20drama%20landscape%20banner%2C%20ancient%20mythological%20palace%20floating%20in%20clouds%2C%20three%20main%20characters%20in%20magnificent%20traditional%20Chinese%20costumes%2C%20dramatic%20golden%20hour%20lighting%2C%20celestial%20atmosphere%20with%20floating%20peach%20blossoms%2C%20cinematic%20widescreen%20composition%2C%20rich%20warm%20colors%20of%20amber%20coral%20and%20gold&width=1600&height=600&seq=banner-longing-2025&orientation=landscape',
    tags: ['热门', '高评分', '古装', '神话'],
    updateDate: '2025-07-28',
    views: 12850000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'blossom-shanghai-2025',
    title: '繁花',
    engTitle: 'Blossoms Shanghai',
    year: 2024,
    category: '都市剧',
    categorySlug: 'urban',
    rating: 9.4,
    description: '九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，从默默无闻的小人物变成商界后起之秀。在黄河路上，他与各路人物相遇、相知、相爱、相离。',
    longDescription: '九十年代的上海，处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，从默默无闻的小人物变成了商界的后起之秀。在黄河路上，阿宝遇见了精明能干的女老板李李、率真执着的汪小姐、神秘莫测的玲子，以及形形色色的人物。在那个遍地黄金的年代，每个人都在为自己的梦想打拼，编织着属于自己的繁花似锦的人生。本剧由王家卫导演倾力打造，以独特的视觉美学再现了上海九十年代的繁华与浪漫。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    region: '中国大陆',
    episodeCount: 30,
    episodeUpdated: 30,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20drama%20TV%20series%20poster%2C%20stylish%20characters%20in%20vintage%20fashion%2C%20neon%20lights%20reflecting%20on%20wet%20street%20at%20night%2C%20atmospheric%20Wong%20Kar%20Wai%20aesthetic%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20nostalgic%20romantic%20mood%2C%20cinematic%20film%20poster%20quality&width=600&height=840&seq=movie-blossom-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20at%20night%20with%20neon%20signs%20and%20vintage%20cars%2C%20stylish%20characters%20walking%20on%20busy%20street%2C%20warm%20golden%20light%20reflecting%20on%20wet%20pavement%2C%20nostalgic%20cinematic%20atmosphere%2C%20Wong%20Kar%20Wai%20film%20aesthetic%2C%20rich%20colors&width=1600&height=600&seq=banner-blossom-2025&orientation=landscape',
    tags: ['热门', '高评分', '都市', '年代'],
    updateDate: '2025-07-26',
    views: 15600000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'the-bad-kids-2024',
    title: '隐秘的角落',
    engTitle: 'The Bad Kids',
    year: 2024,
    category: '悬疑剧',
    categorySlug: 'suspense',
    rating: 9.0,
    description: '三个孩子在景区游玩时，无意中用相机记录下了一场谋杀案。从此，他们的命运被彻底改变。该剧改编自紫金陈推理小说《坏小孩》。',
    longDescription: '沿海小城的暑假，三个孩子在六峰山景区游玩时，无意中用相机记录下了一场谋杀案。从此，原本平静的生活被彻底打破。凶手张东升是一名少年宫的数学老师，表面温文尔雅，内心却隐藏着不可告人的秘密。三个孩子与凶手之间的智斗与博弈由此展开，而更加错综复杂的成人世界也逐渐浮出水面。该剧改编自紫金陈推理小说《坏小孩》，以精湛的叙事和悬疑氛围营造，成为国产悬疑剧的标杆之作。',
    director: '辛爽',
    cast: ['秦昊', '王景春', '荣梓杉', '史彭元', '王圣迪'],
    region: '中国大陆',
    episodeCount: 12,
    episodeUpdated: 12,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20Chinese%20drama%20poster%2C%20three%20children%20standing%20on%20a%20misty%20mountain%20cliff%20overlooking%20small%20coastal%20town%2C%20dark%20atmospheric%20lighting%2C%20ominous%20clouds%2C%20deep%20shadows%2C%20psychological%20thriller%20film%20poster%20aesthetic%2C%20moody%20tones&width=600&height=840&seq=movie-badkids-2024&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Coastal%20Chinese%20small%20town%20at%20sunset%20with%20misty%20mountain%20in%20background%2C%20three%20silhouettes%20of%20children%20on%20cliff%2C%20dark%20moody%20atmosphere%2C%20psychological%20thriller%20cinematic%20landscape%2C%20foreboding%20sky%20with%20dramatic%20clouds%2C%20deep%20teal%20and%20charcoal%20tones&width=1600&height=600&seq=banner-badkids-2024&orientation=landscape',
    tags: ['高分', '悬疑', '犯罪', '烧脑'],
    updateDate: '2025-07-24',
    views: 9800000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'meet-yourself-2025',
    title: '去有风的地方',
    engTitle: 'Meet Yourself',
    year: 2025,
    category: '爱情剧',
    categorySlug: 'romance',
    rating: 8.8,
    description: '北京五星级酒店前厅经理许红豆因闺蜜去世而辞职，独自前往大理云苗村"有风小院"休养调整，与辞去高薪工作回乡创业的谢之遥相遇。',
    longDescription: '许红豆是北京一家五星级酒店的前厅经理，生活看似光鲜，却在闺蜜突然离世后陷入迷茫。她辞去工作，独自前往大理云苗村的"有风小院"休养调整。在那里，她遇见了辞去高薪工作回乡创业的当地青年谢之遥。从最初的互相"看不顺眼"，到逐渐走近彼此内心，两人在苍山洱海之间展开了一段温暖治愈的爱情故事。剧中不仅展现了云南大理的绝美风光，更探讨了当代都市人在快节奏生活中寻找内心平静的主题。',
    director: '丁梓光',
    cast: ['刘亦菲', '李现', '胡冰卿', '牛骏峰', '吴倩'],
    region: '中国大陆',
    episodeCount: 40,
    episodeUpdated: 40,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20drama%20poster%20set%20in%20Dali%20Yunnan%2C%20couple%20standing%20in%20golden%20sunflower%20field%20with%20Erhai%20Lake%20and%20Cangshan%20Mountain%20behind%2C%20warm%20sunset%20lighting%2C%20healing%20pastoral%20atmosphere%2C%20soft%20romantic%20film%20poster%20style&width=600&height=840&seq=movie-meetyourself-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Dali%20Yunnan%20landscape%20with%20Erhai%20Lake%2C%20Cangshan%20Mountain%2C%20golden%20sunflower%20fields%2C%20traditional%20Bai%20architecture%20courtyard%2C%20warm%20golden%20hour%20sunlight%2C%20peaceful%20healing%20atmosphere%2C%20cinematic%20widescreen%20pastoral%20scene&width=1600&height=600&seq=banner-meetyourself-2025&orientation=landscape',
    tags: ['治愈', '爱情', '田园', '高分'],
    updateDate: '2025-07-25',
    views: 11200000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'reset-2025',
    title: '开端',
    engTitle: 'Reset',
    year: 2025,
    category: '科幻剧',
    categorySlug: 'scifi',
    rating: 8.9,
    description: '游戏架构师肖鹤云和大学生李诗情在遭遇公交车爆炸后"死而复生"，陷入时间循环。两人必须在有限的时间内找出真相，阻止即将发生的灾难。',
    longDescription: '游戏架构师肖鹤云和大学生李诗情在遭遇公交车爆炸后"死而复生"，发现自己被困在不断循环的时间中。每次循环都在公交车爆炸的那一瞬间重启。为了逃出循环，两人不得不联手调查车上每一位乘客的背景和秘密，在一次次循环中收集线索，逐步接近真相。然而随着调查深入，他们发现这起事件背后隐藏着更加复杂的阴谋和人生故事。该剧将时间循环与现实主义题材巧妙结合，在悬疑中穿插温情，是一部制作精良的国产科幻悬疑剧。',
    director: '孙墨龙',
    cast: ['白敬亭', '赵今麦', '刘奕君', '刘涛', '黄觉'],
    region: '中国大陆',
    episodeCount: 15,
    episodeUpdated: 15,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20time%20loop%20Chinese%20drama%20poster%2C%20young%20couple%20running%20on%20city%20street%20with%20explosion%20fragments%20frozen%20in%20air%2C%20clock%20motif%2C%20dramatic%20lighting%20with%20glass%20shards%2C%20cyberpunk%20tinted%20atmosphere%2C%20thrilling%20film%20poster%20style&width=600&height=840&seq=movie-reset-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20street%20with%20bus%20in%20motion%2C%20futuristic%20time%20loop%20visual%20effect%20with%20clock%20fragments%20floating%2C%20dramatic%20sky%2C%20sci-fi%20thriller%20atmosphere%2C%20teal%20and%20orange%20color%20contrast%2C%20cinematic%20high%20tension%20scene&width=1600&height=600&seq=banner-reset-2025&orientation=landscape',
    tags: ['科幻', '悬疑', '烧脑', '循环'],
    updateDate: '2025-07-23',
    views: 10500000,
    isHot: false,
    isNew: true,
  },
  {
    id: 'the-long-season-2025',
    title: '漫长的季节',
    engTitle: 'The Long Season',
    year: 2025,
    category: '悬疑剧',
    categorySlug: 'suspense',
    rating: 9.5,
    description: '一座横跨二十年时空的小城桦林，一桩碎尸案串联起几个家庭的命运。出租车司机王响、他的妹夫龚彪，以及刑警支队前队长马德胜，在追寻真相的过程中重新审视各自的人生。',
    longDescription: '小城桦林，出租车司机王响做梦也没想到，他还会遇到二十年前那个最不愿想起的案子。一桩碎尸案串联起几个家庭的命运——王响的儿子王阳二十年前离奇死亡，妻子自杀，一个原本幸福的家庭瞬间崩塌。二十年后，当类似的案件再次浮出水面，王响联合妹夫龚彪和退休刑警马德胜，开始了跨越时空的真相追寻。该剧以精妙的叙事结构和深刻的时代洞察，被誉为近年来国产悬疑剧的最高峰。',
    director: '辛爽',
    cast: ['范伟', '秦昊', '陈明昊', '李庚希', '刘琳'],
    region: '中国大陆',
    episodeCount: 12,
    episodeUpdated: 12,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Noir%20mystery%20Chinese%20drama%20poster%2C%20middle-aged%20taxi%20driver%20in%20small%20industrial%20northeastern%20town%2C%20golden%20autumn%20leaves%20falling%2C%20nostalgic%201990s%20aesthetic%2C%20lonely%20figure%20in%20autumn%20landscape%2C%20film%20noir%20atmosphere%2C%20warm%20amber%20and%20deep%20shadow&width=600&height=840&seq=movie-longseason-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Small%20northeastern%20Chinese%20industrial%20town%20in%20autumn%2C%20golden%20corn%20fields%20stretching%20to%20horizon%2C%20old%20factory%20chimneys%20in%20distance%2C%20train%20tracks%20running%20through%20fields%2C%20nostalgic%201990s%20atmosphere%2C%20warm%20autumn%20colors%2C%20cinematic%20widescreen&width=1600&height=600&seq=banner-longseason-2025&orientation=landscape',
    tags: ['高分', '悬疑', '犯罪', '年代'],
    updateDate: '2025-07-22',
    views: 13200000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'joy-of-life-2-2025',
    title: '庆余年第二季',
    engTitle: 'Joy of Life Season 2',
    year: 2025,
    category: '古装剧',
    categorySlug: 'costume',
    rating: 9.1,
    description: '范闲从上一季的结局中死里逃生，回到京都后面临更加复杂的朝堂局势。他必须凭借智慧在各方势力之间周旋，同时揭开自己身世之谜。',
    longDescription: '范闲从言冰云那一剑下奇迹般生还，重返京都。但他很快发现，朝堂之上的暗流比任何武功都要凶险。二皇子、太子、长公主，各方势力蠢蠢欲动。范闲必须在波诡云谲的权力斗争中保全自己和身边的人，同时继续追查母亲叶轻眉留下的秘密。第二季在延续第一季幽默风格的基础上，加大了权谋戏的深度，人物关系更加错综复杂，笑点与泪点并存。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    region: '中国大陆',
    episodeCount: 36,
    episodeUpdated: 36,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20handsome%20male%20lead%20in%20elegant%20black%20traditional%20robe%20holding%20sword%2C%20ancient%20Chinese%20palace%20rooftop%20at%20night%2C%20dramatic%20moonlight%2C%20epic%20martial%20arts%20atmosphere%2C%20cinematic%20poster%20with%20golden%20accents&width=600&height=840&seq=movie-joyoflife2-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20imperial%20palace%20panorama%20at%20sunset%2C%20thousands%20of%20rooftops%20stretching%20into%20distance%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20epic%20scale%20historical%20setting%2C%20cinematic%20widescreen%2C%20magnificent%20imperial%20architecture&width=1600&height=600&seq=banner-joyoflife2-2025&orientation=landscape',
    tags: ['热门', '权谋', '古装', '高评分'],
    updateDate: '2025-07-21',
    views: 18900000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'she-and-her-girls-2025',
    title: '山花烂漫时',
    engTitle: 'She and Her Girls',
    year: 2025,
    category: '都市剧',
    categorySlug: 'urban',
    rating: 9.3,
    description: '根据张桂梅校长的真实事迹改编。一位普通的女教师在大山深处创办免费女子高中，用教育改变了一千多名贫困女孩的命运。',
    longDescription: '在云南丽江华坪县的大山深处，张桂梅老师目睹了一个又一个女孩因贫困而辍学的悲剧。她立下誓言，要办一所免费的女子高中，让这些女孩通过读书走出大山。没有经费，她四处奔走筹款；没有老师，她用真诚打动志愿者；学生基础差，她从小学课程开始补起。十二年的坚守，她将一千八百多名大山女孩送进了大学，创造了中国教育史上的奇迹。该剧以真实细腻的笔触，展现了一位教育者的无私奉献和一群女孩的成长蜕变。',
    director: '费振翔',
    cast: ['宋佳', '兰西雅', '张月', '聂远', '王天辰'],
    region: '中国大陆',
    episodeCount: 23,
    episodeUpdated: 23,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Inspirational%20Chinese%20drama%20poster%2C%20female%20teacher%20in%20mountain%20village%20classroom%20with%20young%20girls%20students%2C%20sunlight%20streaming%20through%20window%2C%20warm%20hopeful%20atmosphere%2C%20realistic%20documentary%20style%2C%20soft%20natural%20lighting%2C%20touching%20and%20uplifting%20mood&width=600&height=840&seq=movie-shegirls-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Mountain%20village%20in%20Yunnan%20China%20at%20sunrise%2C%20terraced%20fields%20on%20hillsides%2C%20small%20school%20building%20with%20flag%20pole%2C%20golden%20morning%20light%20breaking%20through%20mountains%2C%20hopeful%20and%20uplifting%20atmosphere%2C%20cinematic%20panoramic%20landscape&width=1600&height=600&seq=banner-shegirls-2025&orientation=landscape',
    tags: ['高分', '真实改编', '励志', '感人'],
    updateDate: '2025-07-20',
    views: 8700000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'the-knockout-2024',
    title: '狂飙',
    engTitle: 'The Knockout',
    year: 2024,
    category: '悬疑剧',
    categorySlug: 'suspense',
    rating: 9.1,
    description: '一线刑警安欣与黑恶势力长达二十年的生死搏斗。从意气风发的青年到白发苍苍的中年，他始终没有放弃对正义的坚守。',
    longDescription: '京海市，一线刑警安欣在与黑恶势力的斗争中，屡次遭到保护伞的打击，始终无法将犯罪分子绳之以法。二十年间，从意气风发的青年刑警到白发苍苍的中年人，安欣从未放弃。而曾经的市场鱼贩高启强，在时代浪潮中一步步走上犯罪道路，成为京海最大的黑恶势力头目。两人之间长达二十年的正邪较量，牵涉出政法队伍内部的腐败与斗争。该剧以扫黑除恶为主题，展现了中国法治进程中的艰难与进步。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '吴刚', '张志坚'],
    region: '中国大陆',
    episodeCount: 39,
    episodeUpdated: 39,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20Chinese%20drama%20poster%2C%20two%20middle-aged%20men%20facing%20each%20other%20in%20dark%20alley%2C%20police%20badge%20reflection%2C%20rain%20slicked%20street%2C%20dramatic%20chiaroscuro%20lighting%2C%20noir%20film%20poster%20aesthetic%2C%20intense%20confrontation%20mood&width=600&height=840&seq=movie-knockout-2024&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20night%20skyline%20with%20police%20car%20lights%20reflecting%20on%20wet%20street%2C%20dramatic%20storm%20clouds%2C%20urban%20crime%20drama%20atmosphere%2C%20neon%20signs%20blurred%20in%20background%2C%20cinematic%20noir%20aesthetic%2C%20intense%20high%20contrast%20lighting&width=1600&height=600&seq=banner-knockout-2024&orientation=landscape',
    tags: ['热门', '扫黑', '犯罪', '实力派'],
    updateDate: '2025-07-19',
    views: 20100000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'romance-in-the-alley-2025',
    title: '小巷人家',
    engTitle: 'Romance in the Alley',
    year: 2025,
    category: '爱情剧',
    categorySlug: 'romance',
    rating: 8.7,
    description: '两个不同阶层的家庭因为一纸婚约被绑在一起。在狭窄的上海弄堂里，两代人的命运交织，上演着关于爱情、亲情与成长的故事。',
    longDescription: '上海弄堂深处，一条窄窄的小巷连接着两个世界。庄家世代居住于此，是典型的市井人家；林家则刚搬来不久，是知识分子家庭。因为一桩偶然事件，两个原本毫无交集的家庭被一纸婚约联系在一起。在时代变迁的浪潮中，弄堂里的年轻人面临着理想与现实、爱情与责任的抉择。从八十年代到新世纪初，小巷见证了他们的欢笑、泪水、争吵与和解，也见证了这座城市日新月异的变化。',
    director: '张开宙',
    cast: ['闫妮', '蒋欣', '郭晓东', '李光洁', '关晓彤'],
    region: '中国大陆',
    episodeCount: 37,
    episodeUpdated: 37,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20poster%20set%20in%20Shanghai%20alley%2C%20multi-generational%20family%20standing%20in%20traditional%20lane%20house%20doorway%2C%20warm%20nostalgic%201980s%20atmosphere%2C%20hanging%20laundry%20and%20bicycles%2C%20soft%20golden%20afternoon%20light%2C%20slice%20of%20life%20film%20poster&width=600&height=840&seq=movie-alley-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Shanghai%20traditional%20lilong%20alley%20lane%20houses%20in%20warm%20afternoon%20sunlight%2C%20neighbors%20chatting%20and%20children%20playing%2C%20hanging%20laundry%20between%20buildings%2C%20nostalgic%201980s%20Chinese%20neighborhood%2C%20golden%20light%20filtering%20through%20narrow%20alley%2C%20cinematic%20slice%20of%20life&width=1600&height=600&seq=banner-alley-2025&orientation=landscape',
    tags: ['年代', '家庭', '爱情', '温情'],
    updateDate: '2025-07-18',
    views: 7600000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'under-the-microscope-2025',
    title: '显微镜下的大明',
    engTitle: 'Under the Microscope',
    year: 2025,
    category: '历史剧',
    categorySlug: 'history',
    rating: 8.6,
    description: '改编自马伯庸同名小说。数学天才帅家默无意中发现了一桩百年税赋冤案，他以一己之力挑战整个官僚体系，为底层百姓伸张正义。',
    longDescription: '明朝万历年间，徽州府仁华县。数学天才帅家默在查阅县衙税簿时，无意间发现了一个持续百年的税赋漏洞——人丁丝绢税。这笔本应由六县分摊的税赋，不知为何全部落在了仁华一县百姓的头上。帅家默凭借超凡的算学天赋和一腔正义热血，开始了漫长的查证之路。从县衙到府衙，再到京城，他面对的是一个盘根错节的利益集团。本剧以细腻的历史考据和精妙的叙事，展现了一介布衣如何用智慧撬动庞大官僚体系的传奇故事。',
    director: '潘安子',
    cast: ['张若昀', '王阳', '戚薇', '吴刚', '高亚麟'],
    region: '中国大陆',
    episodeCount: 14,
    episodeUpdated: 14,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Ming%20Dynasty%20historical%20Chinese%20drama%20poster%2C%20scholar%20in%20traditional%20robe%20examining%20ancient%20documents%20by%20candlelight%2C%20abacus%20and%20scrolls%20on%20wooden%20desk%2C%20warm%20candle%20glow%2C%20historical%20mystery%20atmosphere%2C%20rich%20wood%20tones%20and%20amber%20light&width=600&height=840&seq=movie-microscope-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Ming%20Dynasty%20county%20government%20office%20interior%2C%20stacks%20of%20yellowed%20documents%20and%20scrolls%2C%20sunlight%20beams%20through%20wooden%20window%20lattice%2C%20dust%20motes%20in%20light%2C%20historical%20investigation%20atmosphere%2C%20warm%20amber%20wood%20interior&width=1600&height=600&seq=banner-microscope-2025&orientation=landscape',
    tags: ['古装', '推理', '历史', '马伯庸'],
    updateDate: '2025-07-17',
    views: 6900000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'three-body-2025',
    title: '三体',
    engTitle: 'Three-Body',
    year: 2025,
    category: '科幻剧',
    categorySlug: 'scifi',
    rating: 9.0,
    description: '改编自刘慈欣同名科幻巨著。纳米科学家汪淼被卷入一个神秘组织"科学边界"的调查，由此揭开地球文明与三体文明之间跨越光年的博弈。',
    longDescription: '2007年，全球多名顶尖物理学家相继自杀，死前都留下了"物理学不存在了"的遗言。纳米科学家汪淼在警官史强的邀请下，开始调查神秘组织"科学边界"。在调查过程中，汪淼接触到了一款名为《三体》的神秘VR游戏，并在游戏中亲历了一个外星文明在乱纪元中挣扎求生的历史。与此同时，四十年前红岸基地的秘密也逐渐浮出水面。人类文明与三体文明的命运，就此交织在了一起。该剧忠实还原了刘慈欣原著中宏大的宇宙观和深刻的哲学思考。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '王子文', '林永健', '李小冉'],
    region: '中国大陆',
    episodeCount: 30,
    episodeUpdated: 30,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Hard%20science%20fiction%20Chinese%20drama%20poster%2C%20three%20suns%20in%20alien%20sky%20over%20desolate%20landscape%2C%20human%20figure%20silhouette%2C%20cosmic%20scale%2C%20radio%20telescope%20dish%20in%20foreground%2C%20deep%20space%20atmosphere%2C%20mysterious%20and%20epic%20cinematic%20poster&width=600&height=840&seq=movie-threebody-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20cosmic%20scale%20landscape%20with%20Milky%20Way%20galaxy%20over%20Earth%20horizon%2C%20giant%20radio%20telescope%20array%20pointing%20at%20stars%2C%20mysterious%20alien%20signal%20visualization%2C%20deep%20space%20and%20scientific%20atmosphere%2C%20cinematic%20widescreen%20sci-fi&width=1600&height=600&seq=banner-threebody-2025&orientation=landscape',
    tags: ['科幻', '高分', '刘慈欣', '史诗'],
    updateDate: '2025-07-16',
    views: 14500000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'the-rational-life-2025',
    title: '理智派生活',
    engTitle: 'The Rational Life',
    year: 2025,
    category: '都市剧',
    categorySlug: 'urban',
    rating: 8.4,
    description: '34岁的女律师沈若歆在职场遭遇天花板，感情也陷入瓶颈。面对年轻下属的热烈追求和社会对女性"应该在什么年龄做什么事"的期待，她该如何选择？',
    longDescription: '34岁的沈若歆是上海一家知名律所的高级律师，工作能力出众，却在晋升合伙人的路上屡屡受挫。与此同时，周围的亲戚朋友不断催促她结婚生子。比她小12岁的助理祁晓对她展开了热烈追求，而条件优渥的相亲对象徐敏杰也向她抛出了橄榄枝。面对职场的性别歧视、原生家庭的羁绊、以及社会对女性的种种期待，沈若歆用自己的方式做出了选择。该剧以冷静克制的笔触，探讨了当代都市女性的真实处境。',
    director: '徐辅军',
    cast: ['秦岚', '王鹤棣', '包文婧', '潘虹', '李宗翰'],
    region: '中国大陆',
    episodeCount: 35,
    episodeUpdated: 35,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20romance%20Chinese%20drama%20poster%2C%20elegant%20professional%20woman%20in%20law%20office%20with%20city%20skyline%20through%20window%2C%20warm%20afternoon%20light%2C%20contemporary%20urban%20setting%2C%20sophisticated%20atmosphere%2C%20professional%20yet%20romantic%20film%20poster&width=600&height=840&seq=movie-rational-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Shanghai%20Pudong%20skyline%20at%20sunset%20with%20modern%20skyscrapers%2C%20office%20building%20glass%20facade%20reflecting%20golden%20light%2C%20professional%20urban%20atmosphere%2C%20contemporary%20Chinese%20city%2C%20cinematic%20widescreen%2C%20warm%20golden%20hour&width=1600&height=600&seq=banner-rational-2025&orientation=landscape',
    tags: ['都市', '职场', '爱情', '女性'],
    updateDate: '2025-07-15',
    views: 6200000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'legend-of-shen-li-2025',
    title: '与凤行',
    engTitle: 'The Legend of Shen Li',
    year: 2025,
    category: '古装剧',
    categorySlug: 'costume',
    rating: 8.5,
    description: '魔界骁将沈璃为逃脱政治联姻，坠落人间负伤化为凤凰原型，被隐居在人间的最后一位上古神行止所救，两人展开一段跨越仙魔的宿命之恋。',
    longDescription: '灵界碧苍王沈璃，为逃脱与仙界天孙的政治联姻，在逃婚途中被打落人间。重伤之下，她化为凤凰原型，被隐居在人间的最后一位上古神——行止神君所救。行止看穿了她的真身，却以凡人身份与她相处。两人在人间度过了一段平静而温暖的时光，情愫暗生。然而魔界与仙界的纷争并未平息，沈璃必须回到灵界面对属于自己的责任。而行止的身份也远比她想象的更加复杂。一段跨越仙魔之别的宿命之恋，由此展开。',
    director: '邓科',
    cast: ['赵丽颖', '林更新', '辛云来', '何与', '宣璐'],
    region: '中国大陆',
    episodeCount: 39,
    episodeUpdated: 39,
    status: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Xianxia%20Chinese%20fantasy%20drama%20poster%2C%20beautiful%20female%20warrior%20in%20red%20ancient%20armor%20with%20phoenix%20wings%2C%20celestial%20palace%20in%20background%2C%20dramatic%20wind%20and%20fire%20effects%2C%20epic%20fantasy%20atmosphere%2C%20cinematic%20mythological%20poster&width=600&height=840&seq=movie-shenli-2025&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20xianxia%20fantasy%20landscape%20with%20floating%20celestial%20palaces%20among%20clouds%2C%20phoenix%20fire%20bird%20soaring%20through%20golden%20sky%2C%20ancient%20Chinese%20mythological%20atmosphere%2C%20dramatic%20sunset%20colors%20of%20crimson%20and%20gold%2C%20cinematic%20widescreen&width=1600&height=600&seq=banner-shenli-2025&orientation=landscape',
    tags: ['古装', '仙侠', '爱情', '特效'],
    updateDate: '2025-07-14',
    views: 11300000,
    isHot: false,
    isNew: false,
  },
];

export const getMovieById = (id: string): Movie | undefined => {
  return movies.find(m => m.id === id);
};

export const getMoviesByCategory = (slug: string): Movie[] => {
  if (slug === 'all') return movies;
  return movies.filter(m => m.categorySlug === slug);
};

export const getHotMovies = (): Movie[] => {
  return movies.filter(m => m.isHot);
};

export const getNewMovies = (): Movie[] => {
  return movies.filter(m => m.isNew);
};

export const getRelatedMovies = (movie: Movie, count: number = 6): Movie[] => {
  return movies
    .filter(m => m.id !== movie.id && m.categorySlug === movie.categorySlug)
    .slice(0, count);
};